<template>
	<div class="center">
		<div class="team-info">
			<div class="header">
				<img src="@/assets/public/team-icon.png" alt="" />
				<span class="yx-color-black ml-10">团队信息</span>
			</div>
			<div class="content fz-14 mt-20">
				<p>
					<span class="yx-color-text-regular common">团队名称</span>
					<span class="yx-color-text-primary">{{ team_info.team_name }}</span>
				</p>
				<p>
					<span class="yx-color-text-regular common">到期时间 </span>
					<span class="yx-color-text-primary">{{ team_info.expire_time | formatTime('yyyy年MM月dd日') }}</span>
				</p>
				<p>
					<span class="yx-color-text-regular common">管理员姓名</span>
					<span class="yx-color-text-primary">{{ team_info.contacts_name }}</span>
				</p>
				<p>
					<span class="yx-color-text-regular common">管理员手机号</span>
					<span class="yx-color-text-primary">{{ team_mobile }}</span>
				</p>
			</div>
		</div>
		<div class="line"></div>
		<div class="account-info">
			<div class="header">
				<img src="@/assets/public/admin-icon.png" alt="" />
				<span class="yx-color-black ml-10">子账号信息</span>
			</div>
			<div class="content fz-14 mt-20">
				<p>
					<span class="yx-color-text-regular common">账号角色</span>
					<span class="yx-color-text-primary">{{ account_info.role_name }}</span>
				</p>
				<p>
					<span class="yx-color-text-regular common">账号姓名</span>
					<span class="yx-color-text-primary">{{ account_info.partner_role_name }}</span>
				</p>
				<p>
					<span class="yx-color-text-regular common">登录手机号</span>
					<span class="yx-color-text-primary">{{ acc_mobile }}</span>
				</p>
			</div>
		</div>
		<div class="line"></div>
		<div class="bind-info">
			<div class="header flex flex-just-between">
				<div>
					<img src="@/assets/public/wx-icon.png" alt="" />
					<span class="yx-color-black ml-10 fz-14">微信绑定信息</span>
				</div>
				<div>
					<el-button type="primary" class="el-icon-plus" @click="bindFun"> 绑定微信 </el-button>
				</div>
			</div>
			<div class="content fz-14 mt-20">
				<div class="tips fz-14">
					<img src="@/assets/public/warning-blue.png" class="warn_img" alt="" />
					<span class="ml-10"
						>一个子账号可以绑定多个微信，用于同一成员的多微信推荐，业绩数据将按照子账号维度统计，同一微信不能重复绑定多个子账号</span
					>
				</div>
				<div class="bind-box mt-20">
					<div class="item mb-20" v-for="(item, index) in wechat_list" :key="index">
						<div class="top flex">
							<div class="item-left">
								<yx-avatar :src="item.avatar_url" size="small"></yx-avatar>
							</div>
							<div class="item-right ml-12 fz-14">
								<div class="yx-color-black">{{ item.nick_name }}</div>
								<div class="mt-10 fz-14 yx-color-text-primary">{{ item.bind_time }}</div>
							</div>
						</div>
						<div class="bottom mt-20">
							<div class="flex flex-align-center">
								<el-switch
									class="isswitch"
									v-model="item.accept_status"
									active-color="#2475FF"
									disabled
									inactive-color="#ddd"
									@click.native="replaceFun(item, item.nick_name)"
								>
								</el-switch>
								<span class="des">{{ item.accept_status ? '微信提醒已开启' : '微信提醒已关闭' }}</span>
							</div>
							<el-button>
								<span @click="unboundFun(item.account_wechat_id)">解绑微信</span>
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<addWx ref="addWx" @Refresh="Refresh"></addWx>
		<replace ref="replace" @switchChange="switchChange"></replace>
		<Unbound ref="Unbound" @Refresh="Refresh"></Unbound>
		<follow ref="follow" @Refresh="Refresh"></follow>
	</div>
</template>
<script>
import { partnerPersonal, bindqr } from '@/api/personal';
import addWx from './dialog/addWx.vue';
import replace from './dialog/replace.vue';
import follow from './dialog/follow.vue';
import Unbound from './dialog/Unbound.vue';
export default {
	components: {
		addWx,
		replace,
		follow,
		Unbound,
		
	},
	data() {
		return {
			account_info: {},
			team_info: {},
			wechat_list: [],
			switchValue: true,
			team_mobile: '',
			acc_mobile: '',
		};
	},
	created() {
		this.getInfo();
	},
	methods: {
		async getInfo() {
			const { code, data } = await partnerPersonal();
			if (code === 0) {
				const { account_info, team_info, wechat_list } = data;
				this.account_info = account_info;
				this.team_info = team_info;
				this.team_mobile = this.team_info?.mobile.substring(0, 3) + '****' + this.team_info?.mobile.substring(7, 11);
				this.acc_mobile = this.account_info?.mobile.substring(0, 3) + '****' + this.account_info?.mobile.substring(7, 11);
				this.wechat_list = wechat_list;
				if (this.wechat_list.length === 0) {
					location.reload();
				}
			}
		},
		//更换微信提醒
		replaceFun(row, name) {
			if (row.follow_status) {
				if (!row.accept_status) {
					this.$refs.replace.show(row, name, 0);
				} else {
					this.$refs.replace.show(row, name, 1);
				}
			} else {
				this.$refs.follow.show();
			}
		},
		switchChange(row) {
			row.accept_status = !row.accept_status;
			this.getInfo();
		},
		//绑定微信
		async bindFun() {
			let total = this.wechat_list.length;
			const { code, data } = await bindqr({});
			if (code === 0) {
				this.$refs.addWx.show(data.qr_link, total);
			}
		},
		//解绑微信
		unboundFun(id) {
			this.$refs.Unbound.show(id);
		},
		Refresh() {
			this.getInfo();
		},
	},
};
</script>
<style lang='less' scoped>
.header {
	display: flex;
	align-items: center;
	img {
		width: 20px;
		height: 20px;
	}
	span {
		font-weight: 550;
		font-family: PingFangSC-Medium, sans-serif;
	}
}
.content {
	margin-left: 10px;
	p {
		display: flex;
		align-items: center;
		margin-top: 15px;
	}
}
.bind-box {
	display: grid;
	grid-template-columns: repeat(3, 33%);
	grid-gap: 10px 0.6%;
}
.common {
	width: 120px;
}
.line {
	height: 1px;
	background-color: #eeeeee;
	margin: 30px 0px;
}
.warn_img {
	width: 16px;
	height: 16px;
}
.tips {
	display: flex;
	align-items: center;
	padding: 11px 16px;
	background-color: #edf4ff;
	border: 1px solid #94b4eb;
	color: #323233;
}
.item {
	border-radius: 4px;
	border: 1px solid #e3e3e3;
	padding: 16px;
}
.des {
	margin-left: 4px;
}
.bind_btn {
	border: 1px solid #e3e3e3;
	background-color: #fff;
	cursor: default;
}
.bind_text {
	font-size: 13px;
}
.bottom {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.isswitch {
	opacity: 1;
	/deep/ .el-switch__core {
		cursor: pointer !important;
	}
}
</style>